(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["account-tab-addresses"] && !Shopify.designMode) return;
  try {
    (function() {
    var overlay = document.getElementById('address-modal-overlay');
    if (!overlay) return;

    document.querySelectorAll('#account-tab-addresses [data-action="open-modal"]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        overlay.classList.add('is-visible');
      });
    });

    document.querySelectorAll('#account-tab-addresses [data-action="close-modal"]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        overlay.classList.remove('is-visible');
      });
    });

    overlay.addEventListener('click', function() {
      overlay.classList.remove('is-visible');
      document.querySelectorAll('#account-tab-addresses .Modal.is-open').forEach(function(modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      });
      document.body.classList.remove('has-openModal');
      document.documentElement.style.overflow = '';
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cable-carousel"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('[data-carousel]').forEach(function(wrapper) {
      var track = wrapper.querySelector('.CableCarousel');
      if (!track) return;

      var slides = track.querySelectorAll('.CableCarousel__Slide');
      if (slides.length < 2) return;

      var prevBtn = wrapper.querySelector('[data-carousel-prev]');
      var nextBtn = wrapper.querySelector('[data-carousel-next]');
      var dots = wrapper.querySelectorAll('.CableCarousel__Dot');
      var currentIndex = 0;

      function scrollToIndex(index) {
        index = Math.max(0, Math.min(index, slides.length - 1));
        currentIndex = index;
        slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        updateDots();
      }

      function updateDots() {
        dots.forEach(function(dot, i) {
          dot.classList.toggle('is-active', i === currentIndex);
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { scrollToIndex(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { scrollToIndex(currentIndex + 1); });
      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { scrollToIndex(i); });
      });

      // Sync current index on scroll
      var scrollTimeout;
      track.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          var trackLeft = track.scrollLeft;
          var closest = 0;
          var closestDist = Infinity;
          slides.forEach(function(slide, i) {
            var dist = Math.abs(slide.offsetLeft - trackLeft);
            if (dist < closestDist) { closestDist = dist; closest = i; }
          });
          currentIndex = closest;
          updateDots();
        }, 100);
      });

      updateDots();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cable-variant-switching"] && !Shopify.designMode) return;
  try {
    (function() {
    var section = document.querySelector('[data-section-type="product"]');
    if (!section) return;

    var sectionId = section.getAttribute('data-section-id');

    // Listen for variant changes from the existing JS
    document.addEventListener('variant:changed', function(e) {
      var variant = e.detail.variant;
      if (!variant || !sectionId) return;

      var url = window.location.pathname + '?variant=' + variant.id + '&sections=' + sectionId;

      fetch(url, {
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        var html = sections[sectionId];
        if (!html) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Swap inventory indicator
        swapElement('[data-inventory-indicator]', doc);
        // Swap afterpay message
        swapElement('.afterpay-paragraph', doc);
      })
      .catch(function(err) {
        console.warn('Variant section fetch failed:', err);
      });
    });

    function swapElement(selector, sourceDoc) {
      var target = section.querySelector(selector);
      var source = sourceDoc.querySelector(selector);
      if (target && source) {
        target.innerHTML = source.innerHTML;
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer-rewards"] && !Shopify.designMode) return;
  try {
    (function () {
      // Cable Collective monogram (the "C" swoosh), extracted from icon-collective.
      var ICON_SVG = '<svg viewBox="28 -4 102 80" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
        + '<path d="M101.596 21.0014C100.344 19.1428 98.9123 17.473 97.2922 15.9722C95.6721 14.4714 93.8433 13.1495 91.7859 11.9966C87.7705 9.7702 83.5265 8.65701 79.0439 8.65701C71.7287 8.65701 65.4372 11.3008 60.1794 16.5885C54.9216 21.8463 52.2877 28.1079 52.2877 35.3834C52.2877 42.6589 54.9216 48.9702 60.1794 54.2281C65.4372 59.4759 71.7287 62.1098 79.0439 62.1098C83.4569 62.1098 87.6711 61.0165 91.6865 58.82C95.7318 56.6632 99.0018 53.6814 101.496 49.8747L108.732 54.6256C107.072 57.0806 105.194 59.297 103.067 61.255C100.94 63.2031 98.5445 64.9127 95.8809 66.3638C90.5535 69.1964 84.9378 70.6078 79.0439 70.6078C69.2936 70.6078 60.9745 67.1688 54.0569 60.2909C47.1094 53.3435 43.6406 45.0343 43.6406 35.3536C43.6406 25.6729 47.1193 17.4134 54.0569 10.4659C61.0342 3.48865 69.3632 0 79.0439 0C84.9776 0 90.6131 1.471 95.9306 4.42293C101.258 7.36492 105.552 11.3406 108.832 16.33L101.596 20.9816V21.0014Z" fill="#171616"/>'
        + '<path d="M125.161 66.6113C125.161 66.6113 100.879 48.6115 75.0474 31.4565C53.6782 17.2733 45.1206 11.598 42.8048 10.0575C42.924 9.57043 43.0036 9.06354 43.0036 8.5467C43.0036 5.15744 40.2504 2.4043 36.8612 2.4043C33.4719 2.4043 30.7188 5.15744 30.7188 8.5467C30.7188 11.936 33.4719 14.6891 36.8612 14.6891C38.362 14.6891 39.7435 14.1424 40.8169 13.2479C43.2421 14.8879 51.8196 20.6526 72.8409 34.7861C98.5734 52.0902 124.495 67.6251 124.495 67.6251C124.584 67.6748 124.674 67.7046 124.783 67.7046C125.121 67.7046 125.399 67.4263 125.399 67.0884C125.399 66.8896 125.3 66.7206 125.161 66.6113ZM36.8612 11.7074C35.1119 11.7074 33.6906 10.2861 33.6906 8.53676C33.6906 6.78747 35.1119 5.36617 36.8612 5.36617C38.6104 5.36617 40.0317 6.78747 40.0317 8.53676C40.0317 10.2861 38.6104 11.7074 36.8612 11.7074Z" fill="#171616"/>'
        + '</svg>';

      function fmtRewardValue(amount) {
        var v = Number(amount);
        if (!isFinite(v)) return '';
        return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
      }

      function daysUntilExpiry(expiresAt) {
        if (!expiresAt) return '';
        var datePart = String(expiresAt).split('T')[0];
        var parts = datePart.split('-');
        var expiry = parts.length === 3
          ? new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]))
          : new Date(expiresAt);
        if (isNaN(expiry.getTime())) return '';
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        expiry.setHours(0, 0, 0, 0);
        return Math.round((expiry.getTime() - today.getTime()) / 86400000);
      }

      // Returns the "Expires today / Expires in N days" copy, or '' when the
      // voucher is more than 7 days from expiry (no badge).
      function expiryLabel(expiresAt) {
        var days = daysUntilExpiry(expiresAt);
        if (days === '') return '';
        if (days > 7) return '';
        if (days <= 0) return 'EXPIRES TODAY';
        return 'EXPIRES IN ' + days + ' DAY' + (days === 1 ? '' : 'S');
      }

      function esc(value) {
        return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      // #601 perf (27 Jun): the loyalty rewards API (`api-rewardsAccount`) is a
      // slow external AP21 app-proxy call. The customer's available rewards do
      // NOT change when a voucher is applied/removed (redemption happens at the
      // order, not at cart-add) — the "applied" state lives in the cart line
      // items. So fetch the rewards ONCE per session and cache them; every drawer
      // refresh (apply / remove / qty change) then only re-reads the fast local
      // /cart.json and re-filters. This makes apply + un-apply feel instant
      // instead of waiting on AP21 each time.
      var rewardsCache = null;
      var rewardsCacheEmail = null;
      var rewardsCacheTime = 0;
      var REWARDS_CACHE_TTL = 5 * 60 * 1000; // refresh the AP21 data at most every 5 min

      window.__loadCartDrawerRewards = function (opts) {
        opts = opts || {};
        var root = document.querySelector('[data-cart-drawer-rewards]');

        if (!root || !root.dataset.customerEmail) return;

        var theme = window.theme || {};
        var loyaltyUrl = theme.loyaltyUrl || '';
        var loyaltyRewardId = theme.loyaltyRewardId || '';
        var localeRootUrl = theme.localeRootUrl || '';
        var email = root.dataset.customerEmail;

        var loadingEl = root.querySelector('[data-cart-drawer-rewards-loading]');
        var contentEl = root.querySelector('[data-cart-drawer-rewards-content]');
        var errorEl = root.querySelector('[data-cart-drawer-rewards-error]');
        if (!contentEl) return;

        if (errorEl) errorEl.hidden = true;

        // Rewards: use the cached AP21 response when fresh; otherwise fetch it
        // (the spinner shows only for this slow call). /cart.json is always read
        // fresh — it's local and fast.
        var now = Date.now();
        var cacheValid = rewardsCache && rewardsCacheEmail === email &&
          (now - rewardsCacheTime) < REWARDS_CACHE_TTL && !opts.forceRewards;
        var rewardsPromise;
        if (cacheValid) {
          rewardsPromise = Promise.resolve(rewardsCache);
        } else {
          if (loadingEl) loadingEl.hidden = false;
          rewardsPromise = fetch(loyaltyUrl + '/apps/dotapparel21/api-rewardsAccount', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: email })
          }).then(function (r) { return r.json(); })
            .then(function (json) {
              var data = (json && json.data) ? json.data : null;
              if (data) { rewardsCache = data; rewardsCacheEmail = email; rewardsCacheTime = Date.now(); }
              return data;
            });
        }

        Promise.all([
          rewardsPromise,
          fetch(localeRootUrl + '/cart.json').then(function (r) { return r.json(); })
        ])
          .then(function (results) {
            var loyalty = results[0];
            var cart = results[1];
            if (loadingEl) loadingEl.hidden = true;

            if (!loyalty) { hideModule(root); return; }

            // Filter: available > 0, not expired, and not already in the cart.
            var rewards = (loyalty.rewards || []).filter(function (r) {
              if (Number(r.available) <= 0) return false;
              var daysToExpiry = daysUntilExpiry(r.expires_at);
              if (daysToExpiry === '' || daysToExpiry < 0) return false;
              // #601 QA (Devon 26 Jun): an applied reward must drop out of the
              // bar so it can't be added again. Shopify stores line-item
              // properties as strings, while the loyalty API returns a numeric
              // id — so compare as strings, not strict ===, or the match (and
              // the exclusion) silently fails.
              var inCart = cart && cart.items && cart.items.some(function (item) {
                return item.properties && String(item.properties._reward_id) === String(r.id);
              });
              return !inCart;
            });

            if (!rewards.length) { hideModule(root); return; }

            renderRewards(root, contentEl, rewards, cart, {
              loyaltyRewardId: loyaltyRewardId,
              localeRootUrl: localeRootUrl
            });
            showModule(root);
          })
          .catch(function (e) {
            console.warn('Cart drawer rewards error:', e);
            if (loadingEl) loadingEl.hidden = true;
            hideModule(root);
          });
      };

      function showModule(root) {
        root.hidden = false;
        // Hide the guest free-shipping widget when the reward module is shown.
        var drawer = document.getElementById('sidebar-cart');
        if (drawer) {
          var fs = drawer.querySelector('.free-shipping-progress');
          if (fs) fs.style.display = 'none';
        }
      }

      function hideModule(root) { root.hidden = true; }

      // Builds one reward card (icon + label + optional expiry badge + value + APPLY).
      // Mirrors the Figma "reward" node tree exactly:
      //   reward (card) > Reward item [icon + details(link(label+value) + expiry)] + APPLY
      // The Reward item is items-center when a badge shows, items-start otherwise
      // (matches the Figma per-card alignment).
      function cardHtml(reward) {
        var expiry = expiryLabel(reward.expires_at);
        return '<div class="CartDrawerRewards__Card">'
          + '<div class="CartDrawerRewards__Item' + (expiry ? ' CartDrawerRewards__Item--center' : '') + '">'
          + '<span class="CartDrawerRewards__Icon">' + ICON_SVG + '</span>'
          + '<div class="CartDrawerRewards__Details">'
          + '<div class="CartDrawerRewards__Link">'
          + '<span class="CartDrawerRewards__Label">Cable Collective Reward</span>'
          + '<span class="CartDrawerRewards__Value">' + esc(fmtRewardValue(reward.available)) + '</span>'
          + '</div>'
          + (expiry ? '<span class="CartDrawerRewards__Expiry">' + esc(expiry) + '</span>' : '')
          + '</div>'
          + '</div>'
          + '<button type="button" class="CartDrawerRewards__Apply" '
          + 'data-action="apply-cart-drawer-reward" '
          + 'data-reward-id="' + esc(reward.id) + '" '
          + 'data-reward-amount="' + esc(reward.available) + '" '
          + 'data-reward-expiry="' + esc(reward.expires_at) + '">APPLY</button>'
          + '</div>';
      }

      // #601 QA (Devon 26 Jun): both single AND multiple rewards are collapsed by
      // default behind the "Your reward(s) (N)" bar with a Show control (match the
      // design — previously a single reward was shown directly). Expanding reveals
      // the list with a Collapse control.
      // Sort = soonest expiry first, then highest value. Stable sort preserves
      // the API order for equal values.
      function renderRewards(root, contentEl, rewards, cart, ctx) {
        var shouldExpand = root.classList.contains('is-expanded') || window.__cartDrawerRewardsKeepExpanded === true;
        window.__cartDrawerRewardsKeepExpanded = false;

        rewards = rewards.slice().sort(function (a, b) {
          var expiryDiff = daysUntilExpiry(a.expires_at) - daysUntilExpiry(b.expires_at);
          if (expiryDiff !== 0) return expiryDiff;
          return Number(b.available) - Number(a.available);
        });

        var count = rewards.length;
        var cards = '';
        for (var i = 0; i < count; i++) cards += cardHtml(rewards[i]);

        // #601 QA: chevron points UP when collapsed (Devon: the arrow was inverted
        // vs the design); the toggle's [aria-expanded="true"] rotates it 180° to
        // point down when the list is open.
        var chevron = '<svg class="CartDrawerRewards__ToggleIcon" viewBox="0 0 10 6" fill="none" aria-hidden="true">'
          + '<path d="M1 5L5 1L9 5" stroke="currentColor" stroke-width="1.2"/></svg>';

        // Singular "reward" for one, plural "rewards" for many.
        var titleNoun = count === 1 ? 'reward' : 'rewards';

        root.classList.toggle('is-expanded', shouldExpand);

        var html = '<div class="CartDrawerRewards__Header">'
          + '<span class="CartDrawerRewards__Title">Your ' + titleNoun + ' (' + count + ')</span>'
          + '<button type="button" class="CartDrawerRewards__Toggle" '
          + 'data-action="toggle-cart-drawer-rewards" aria-expanded="' + (shouldExpand ? 'true' : 'false') + '" '
          + 'aria-controls="cart-drawer-rewards-list" '
          + 'data-label-collapsed="Show" data-label-expanded="Collapse">'
          + '<span data-cart-drawer-rewards-toggle-label>' + (shouldExpand ? 'Collapse' : 'Show') + '</span>' + chevron + '</button>'
          + '</div>';

        // Collapsed by default: max-height 0 (CSS) + inert (not tabbable). The
        // toggle animates it open and clears inert. Not `hidden`/display:none so
        // the open/close height can animate.
        html += '<div class="CartDrawerRewards__List' + (shouldExpand ? ' is-open' : '') + '" id="cart-drawer-rewards-list"' + (shouldExpand ? '' : ' inert') + '>' + cards + '</div>';

        contentEl.innerHTML = html;
      }

      // Initial load + re-init after refreshCartDrawer() swaps #sidebar-cart HTML.
      window.__loadCartDrawerRewards();

      var drawer = document.getElementById('sidebar-cart');
      if (drawer && !drawer.__cartDrawerRewardsObserved) {
        drawer.__cartDrawerRewardsObserved = true;
        // Re-init only when something OUTSIDE the reward module changes (e.g. the
        // drawer HTML swapped by refreshCartDrawer). Ignore the module's own
        // content renders — otherwise the render mutation re-triggers the load in
        // a loop (continuous re-fetch of the rewards API).
        new MutationObserver(function (records) {
          var external = records.some(function (r) {
            var t = r.target;
            return !(t && t.nodeType === 1 && t.closest('[data-cart-drawer-rewards]'));
          });
          if (external) window.__loadCartDrawerRewards();
        }).observe(drawer, { childList: true, subtree: true });
      }
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["find-in-store"] && !Shopify.designMode) return;
  try {
    (function() {
  if (!window.location.pathname.includes('/products/')) return;

  var STOCK_THRESHOLD = 2;
  var MAPS_API_KEY = 'AIzaSyAQPVUx-B64ZnF83_CD43APcKCUpe04X7Q';
  var CIC_DISTANCE_LIMIT = 50;
  var STOCK_ENDPOINT = '/apps/dotapparel21/api-checkStock?sku=';
  var NO_DISTANCE = 9999;

  var COPY = {
    sortStock: 'Sorted by stock availability',
    sortDistance: 'Sorted by distance',
    ccAvailable: 'Click & Collect available',
    ccUnavailable: 'Click & Collect unavailable',
    directions: 'Get Directions',
    hoursClosed: '+ Store Hours',
    hoursOpen: '- Store Hours',
    details: 'Store details',
    noResults: 'No stores found near that location',
    failure: 'We could not check stock just now. Please try again.'
  };

  var STOCK_LABELS = {
    'in': 'In Stock',
    'low': 'Low Stock - Call store to confirm',
    'out': 'Out of Stock'
  };

  var STOCK_RANK = { 'in': 0, 'low': 1, 'out': 2 };

  var STATE_NAMES = {
    VIC: 'Victoria',
    NSW: 'New South Wales',
    QLD: 'Queensland',
    WA: 'Western Australia',
    SA: 'South Australia',
    TAS: 'Tasmania',
    ACT: 'Australian Capital Territory',
    NT: 'Northern Territory'
  };

  var STATE_PATTERN = /\b(VIC|NSW|QLD|WA|SA|TAS|ACT|NT)\b/g;

  var HTML_ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

  /* ---------------------------------------------------------------------------
     Pure helpers
     ------------------------------------------------------------------------- */

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  function getStoreName(name) {
    var parts = String(name || '').trim().split('- ');
    return (parts[1] || parts[0]).trim();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(ch) {
      return HTML_ESCAPES[ch];
    });
  }

  function cleanText(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  function richTextNodeText(node) {
    if (!node) return '';
    if (node.type === 'text') return node.value || '';
    if (!Array.isArray(node.children)) return '';
    return node.children.map(richTextNodeText).join('');
  }

  // Safer replacement for the old serializeRichText: returns one plain-text
  // string per block (paragraph, heading, list item). Never returns HTML.
  function richTextLines(value) {
    if (!value) return [];
    if (typeof value === 'string') return richTextStringLines(value);
    if (value.type !== 'root' || !Array.isArray(value.children)) return [];

    return value.children.reduce(function(lines, node) {
      if (node && node.type === 'list' && Array.isArray(node.children)) {
        return lines.concat(node.children.map(richTextNodeText));
      }
      return lines.concat(richTextNodeText(node));
    }, []);
  }

  function richTextStringLines(value) {
    var trimmed = value.trim();
    if (trimmed.charAt(0) === '{') {
      try {
        return richTextLines(JSON.parse(trimmed));
      } catch (e) {
        // Not JSON: treat as plain text below.
      }
    }
    return trimmed.split(/\r?\n/);
  }

  // Joins address paragraphs on one line. Merchant data keeps its case.
  function formatAddress(paragraphs) {
    return paragraphs
      .map(cleanText)
      .filter(Boolean)
      .join(', ')
      .replace(/\s+,/g, ',')
      .replace(/,(\s*,)+/g, ',')
      .replace(/^[,\s]+|[,\s]+$/g, '');
  }

  function getStateName(addressText) {
    var matches = String(addressText || '').match(STATE_PATTERN);
    if (!matches) return '';
    return STATE_NAMES[matches[matches.length - 1]] || '';
  }

  function slugify(text) {
    var slug = String(text || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return slug || 'store';
  }

  function uniqueKey(base, usedKeys) {
    var key = base;
    var suffix = 2;
    while (usedKeys.has(key)) {
      key = base + '-' + suffix;
      suffix += 1;
    }
    usedKeys.add(key);
    return key;
  }

  function toTelHref(phone) {
    var trimmed = String(phone || '').trim();
    var digits = trimmed.replace(/\D/g, '');
    if (!digits) return '';
    return 'tel:' + (trimmed.charAt(0) === '+' ? '+' : '') + digits;
  }

  function safeHttpsUrl(url) {
    var trimmed = String(url || '').trim();
    return /^https:\/\//i.test(trimmed) ? trimmed : '';
  }

  function toCoordinate(value) {
    var number = parseFloat(value);
    return isFinite(number) ? number : null;
  }

  function buildStore(raw, usedKeys) {
    var displayName = getStoreName(raw.name);
    var addressText = formatAddress(richTextLines(raw.address));

    return {
      key: uniqueKey(slugify(displayName), usedKeys),
      displayName: displayName,
      addressText: addressText,
      stateName: getStateName(addressText),
      hoursLines: richTextLines(raw.hours).map(cleanText).filter(Boolean),
      phone: cleanText(raw.phone),
      phoneHref: toTelHref(raw.phone),
      directionHref: safeHttpsUrl(raw.direction),
      detailsHref: raw.handle ? '/pages/' + encodeURIComponent(raw.handle) : '',
      ccEnabled: raw.clickCollect !== false,
      latitude: toCoordinate(raw.latitude),
      longitude: toCoordinate(raw.longitude),
      distance: NO_DISTANCE
    };
  }

  function buildStores(rawStores) {
    var usedKeys = new Set();
    return (Array.isArray(rawStores) ? rawStores : [])
      .filter(function(raw) { return raw && raw.category !== 'Concession'; })
      .map(function(raw) { return buildStore(raw, usedKeys); });
  }

  function normaliseName(name) {
    return cleanText(name).toLowerCase();
  }

  function stockLevel(quantity) {
    if (quantity > STOCK_THRESHOLD) return 'in';
    if (quantity > 0) return 'low';
    return 'out';
  }

  // AP21 only returns rows for stores holding stock; a missing row is Out of Stock.
  function storeLevel(store, quantities) {
    return stockLevel(quantities[normaliseName(store.displayName)] || 0);
  }

  function hasVisibleStock(stores, quantities) {
    return stores.some(function(store) { return storeLevel(store, quantities) !== 'out'; });
  }

  // AP21 response: { data: [ { attributes: { storeName, freeStock } } ] }.
  // storeName can carry trailing spaces, so names are normalised.
  function parseStockResponse(json) {
    if (!json || typeof json !== 'object') throw new Error('Unexpected stock response');
    var rows = Array.isArray(json.data) ? json.data : Object.values(json)[0];
    if (!Array.isArray(rows)) throw new Error('Unexpected stock response');

    return rows.reduce(function(quantities, row) {
      var attributes = row && row.attributes;
      if (!attributes || typeof attributes.storeName !== 'string') return quantities;
      var name = normaliseName(attributes.storeName);
      quantities[name] = (quantities[name] || 0) + (Number(attributes.freeStock) || 0);
      return quantities;
    }, {});
  }

  function calcDistance(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  function sortByDistance(stores, lat, lng, tiebreak) {
    stores.forEach(function(store) {
      if (store.latitude && store.longitude) {
        store.distance = calcDistance(lat, lng, store.latitude, store.longitude);
      } else {
        store.distance = NO_DISTANCE;
      }
    });
    stores.sort(function(a, b) {
      return (a.distance - b.distance) || (tiebreak ? tiebreak(a, b) : 0);
    });
  }

  function formatDistance(km) {
    var rounded = Math.round(km * 10) / 10;
    var text = rounded < 10 ? rounded.toFixed(1) : String(Math.round(km));
    return text + ' km away';
  }

  // Unknown stock (still loading) ranks equally, which leaves plain A–Z.
  function stockRank(level) {
    return level ? STOCK_RANK[level] : 0;
  }

  function compareStockThenName(a, b) {
    return (stockRank(a.level) - stockRank(b.level)) || a.displayName.localeCompare(b.displayName);
  }

  // Splits stores into the main list and the "without stock" group, sorted by
  // stock then A–Z, or by distance (stock then A–Z as tiebreaks) with a location.
  function buildView(stores, quantities, location, maxDistance) {
    var entries = stores.map(function(store) {
      return Object.assign({}, store, { level: quantities ? storeLevel(store, quantities) : null });
    });

    if (location) {
      sortByDistance(entries, location.lat, location.lng, compareStockThenName);
      if (maxDistance) {
        entries = entries.filter(function(entry) { return entry.distance <= maxDistance; });
      }
    } else {
      entries.sort(compareStockThenName);
    }

    return {
      main: entries.filter(function(entry) { return entry.level !== 'out'; }),
      noStock: entries.filter(function(entry) { return entry.level === 'out'; })
    };
  }

  /* ---------------------------------------------------------------------------
     Sizes (from the product JSON and the page's swatches)
     ------------------------------------------------------------------------- */

  function getOptionNames(product) {
    return (product.options || []).map(function(option) {
      if (typeof option === 'string') return option;
      return (option && option.name) || '';
    });
  }

  function getSizeIndex(optionNames) {
    for (var i = 0; i < optionNames.length; i++) {
      if (/size/i.test(optionNames[i])) return i;
    }
    return optionNames.length - 1;
  }

  // Variants matching the page's other selected options (e.g. colour); all variants if none match.
  function filterVariantsBySelection(variants, selected, sizeIndex) {
    var matches = variants.filter(function(variant) {
      return Object.keys(selected).every(function(index) {
        return Number(index) === sizeIndex || variant.options[index] === selected[index];
      });
    });
    return matches.length ? matches : variants;
  }

  function buildSizes(variants, sizeIndex) {
    var seen = new Set();
    return variants.reduce(function(sizes, variant) {
      var value = variant.options && variant.options[sizeIndex];
      if (value == null || seen.has(String(value))) return sizes;
      seen.add(String(value));
      sizes.push({ value: String(value), sku: variant.sku ? String(variant.sku) : '', variantId: variant.id });
      return sizes;
    }, []);
  }

  function getProductSection() {
    return document.querySelector('[data-section-type="product"]');
  }

  function readProductJson(section) {
    var el = (section && section.querySelector('[data-product-json]')) || document.querySelector('[data-product-json]');
    if (!el) return null;

    try {
      var data = JSON.parse(el.textContent);
      return data && data.product ? data.product : null;
    } catch (e) {
      return null;
    }
  }

  function readPageSelections(section, optionCount) {
    var selected = {};
    if (!section) return selected;

    for (var i = 0; i < optionCount; i++) {
      var checked = section.querySelector('input[name="option-' + i + '"]:checked');
      if (checked) selected[i] = checked.value;
    }
    return selected;
  }

  function readSingleVariant(section, product) {
    var scope = section || document;
    var input = scope.querySelector('input[name="id"][data-sku]');
    if (input && input.getAttribute('data-sku')) {
      return { value: '', sku: input.getAttribute('data-sku'), variantId: input.value };
    }

    var variant = product && product.variants && product.variants[0];
    if (!variant) return null;
    return { value: '', sku: variant.sku ? String(variant.sku) : '', variantId: variant.id };
  }

  function readSizeModel() {
    var section = getProductSection();
    var product = readProductJson(section);
    var variants = (product && product.variants) || [];

    if (variants.length <= 1) {
      var single = readSingleVariant(section, product);
      return { sizeIndex: -1, sizes: single ? [single] : [], hasSizeControl: false, pageSize: null };
    }

    var names = getOptionNames(product);
    var sizeIndex = getSizeIndex(names);
    var selected = readPageSelections(section, names.length);

    return {
      sizeIndex: sizeIndex,
      sizes: buildSizes(filterVariantsBySelection(variants, selected, sizeIndex), sizeIndex),
      hasSizeControl: true,
      pageSize: selected[sizeIndex] == null ? null : String(selected[sizeIndex])
    };
  }

  /* ---------------------------------------------------------------------------
     Stock requests (cached per SKU for the page lifetime)
     ------------------------------------------------------------------------- */

  function fetchAp21Stock(sku) {
    if (!sku) return Promise.reject(new Error('Variant has no SKU'));

    return fetch(STOCK_ENDPOINT + encodeURIComponent(sku))
      .then(function(res) {
        if (!res.ok) throw new Error('Stock request failed (' + res.status + ')');
        return res.json();
      })
      .then(parseStockResponse);
  }

  // Dormant per #668: Storefront API stock source for the Click & Collect modal.
  function checkStockStorefront(variantId) {
    var sfKey = window.theme && window.theme.storeFrontKey;
    if (!sfKey || !variantId) return Promise.reject(new Error('Storefront stock check unavailable'));

    var query = 'query{node(id:"gid://shopify/ProductVariant/' + variantId + '"){...on ProductVariant{id storeAvailability(first:250){edges{node{location{name}quantityAvailable}}}}}}';

    return fetch('/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': sfKey
      },
      body: JSON.stringify({ query: query })
    })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var node = data && data.data && data.data.node;
        var edges = node && node.storeAvailability ? node.storeAvailability.edges : [];
        return edges.reduce(function(quantities, edge) {
          quantities[normaliseName(edge.node.location.name)] = edge.node.quantityAvailable || 0;
          return quantities;
        }, {});
      });
  }

  function stockKey(ctx, size) {
    return ctx.isCic ? 'variant:' + size.variantId : size.sku;
  }

  function requestStock(ctx, size) {
    return ctx.isCic ? checkStockStorefront(size.variantId) : fetchAp21Stock(size.sku);
  }

  function getEntry(ctx, size) {
    return size ? ctx.cache.get(stockKey(ctx, size)) : null;
  }

  // Starts (or retries a failed) request for one size. Resolves with the cache entry.
  function ensureStock(ctx, size) {
    var key = stockKey(ctx, size);
    var existing = ctx.cache.get(key);
    if (existing && existing.status !== 'error') return existing.promise;

    var entry = { status: 'pending', quantities: null, promise: null };
    ctx.cache.set(key, entry);
    entry.promise = requestStock(ctx, size)
      .then(function(quantities) {
        entry.status = 'ok';
        entry.quantities = quantities;
      }, function(err) {
        entry.status = 'error';
        console.warn('Stock check failed:', err);
      })
      .then(function() {
        onStockSettled(ctx, key);
        return entry;
      });
    return entry.promise;
  }

  function fetchAllStock(ctx) {
    return Promise.allSettled(ctx.sizes.map(function(size) {
      return ensureStock(ctx, size);
    }));
  }

  function retryFailedStock(ctx) {
    var failed = ctx.sizes.filter(function(size) {
      var entry = getEntry(ctx, size);
      return entry && entry.status === 'error';
    });
    if (!failed.length) return;

    failed.forEach(function(size) { ensureStock(ctx, size); });
    renderSizeOptions(ctx);
    render(ctx);
  }

  function isSoldOut(ctx, size) {
    var entry = getEntry(ctx, size);
    return !!entry && entry.status === 'ok' && !hasVisibleStock(ctx.stores, entry.quantities);
  }

  function onStockSettled(ctx, key) {
    var resolved = resolveAutoSize(ctx);
    renderSizeOptions(ctx);
    var selected = findSize(ctx, ctx.selectedSize);
    if (resolved || (selected && stockKey(ctx, selected) === key)) render(ctx);
  }

  // With no page size selected, the modal shows the first size with stock in a
  // visible store (fallback: first size). Decided once every earlier size settles.
  function resolveAutoSize(ctx) {
    if (!ctx.autoSelect) return false;

    for (var i = 0; i < ctx.sizes.length; i++) {
      var entry = getEntry(ctx, ctx.sizes[i]);
      if (!entry || entry.status === 'pending') return false;
      if (entry.status === 'ok' && hasVisibleStock(ctx.stores, entry.quantities)) {
        return finishAutoSize(ctx, ctx.sizes[i].value);
      }
    }
    return finishAutoSize(ctx, ctx.sizes.length ? ctx.sizes[0].value : '');
  }

  function finishAutoSize(ctx, value) {
    ctx.autoSelect = false;
    ctx.selectedSize = value;
    updateSizeLabel(ctx);
    return true;
  }

  /* ---------------------------------------------------------------------------
     Rendering
     ------------------------------------------------------------------------- */

  function renderStatus(store) {
    if (!store.level) return '';

    var available = store.level !== 'out' && store.ccEnabled;
    return '<span class="StoreCard__stock StoreCard__stock--' + store.level + '">' + escapeHtml(STOCK_LABELS[store.level]) + '</span>' +
      '<span class="StoreCard__cc StoreCard__cc--' + (available ? 'available' : 'unavailable') + '">' +
        escapeHtml(available ? COPY.ccAvailable : COPY.ccUnavailable) +
      '</span>';
  }

  function renderCardHead(ctx, store) {
    var hasDistance = ctx.location && store.distance < NO_DISTANCE;
    var meta = hasDistance ? formatDistance(store.distance) : store.stateName;

    return '<div class="StoreCard__head">' +
      '<div class="StoreCard__identity">' +
        '<h3 class="StoreCard__name">' + escapeHtml(store.displayName) + '</h3>' +
        (meta ? '<p class="StoreCard__meta">' + escapeHtml(meta) + '</p>' : '') +
      '</div>' +
      '<div class="StoreCard__status">' + renderStatus(store) + '</div>' +
    '</div>';
  }

  function renderCardDetails(store) {
    var addressText = store.addressText ? '<span class="StoreCard__addressText">' + escapeHtml(store.addressText) + '</span>' : '';
    var directions = store.directionHref
      ? '<a class="StoreCard__link" href="' + escapeHtml(store.directionHref) + '" target="_blank" rel="noopener">' + escapeHtml(COPY.directions) + '</a>'
      : '';
    var address = addressText || directions
      ? '<p class="StoreCard__address">' + addressText + (addressText && directions ? ' ' : '') + directions + '</p>'
      : '';
    var phone = store.phoneHref
      ? '<a class="StoreCard__phone" href="' + escapeHtml(store.phoneHref) + '">' + escapeHtml(store.phone) + '</a>'
      : '';

    if (!address && !phone) return '';
    return '<div class="StoreCard__details">' + address + phone + '</div>';
  }

  function renderCardHours(ctx, store) {
    if (!store.hoursLines.length) return '';

    var expanded = ctx.expanded.has(store.key);
    var bodyId = escapeHtml(ctx.modalId + '-hours-' + store.key);
    var hidden = expanded ? '' : ' hidden';
    var details = store.detailsHref
      ? '<a class="StoreCard__link" href="' + escapeHtml(store.detailsHref) + '"' + hidden + ' data-store-details>' + escapeHtml(COPY.details) + '</a>'
      : '';
    var lines = store.hoursLines.map(function(line) { return '<p>' + escapeHtml(line) + '</p>'; }).join('');

    return '<div class="StoreCard__hours">' +
      '<div class="StoreCard__hoursRow">' +
        '<button type="button" class="StoreCard__hoursToggle" aria-expanded="' + expanded + '" aria-controls="' + bodyId + '">' +
          escapeHtml(expanded ? COPY.hoursOpen : COPY.hoursClosed) +
        '</button>' +
        details +
      '</div>' +
      '<div class="StoreCard__hoursBody" id="' + bodyId + '"' + hidden + '>' + lines + '</div>' +
    '</div>';
  }

  function renderCard(ctx, store) {
    return '<article class="StoreCard" data-store-key="' + escapeHtml(store.key) + '">' +
      renderCardHead(ctx, store) +
      renderCardDetails(store) +
      renderCardHours(ctx, store) +
    '</article>';
  }

  function renderCards(ctx, stores) {
    return stores.map(function(store) { return renderCard(ctx, store); }).join('');
  }

  function getStockState(ctx) {
    if (!ctx.sizes.length) return 'error';
    if (ctx.autoSelect) return 'loading';

    var entry = getEntry(ctx, findSize(ctx, ctx.selectedSize));
    if (!entry || entry.status === 'pending') return 'loading';
    return entry.status;
  }

  function showMessage(ctx, text) {
    var els = ctx.els;
    els.list.hidden = !!text;
    if (text && els.noStockGroup) els.noStockGroup.hidden = true;
    if (!els.message) return;
    els.message.textContent = text;
    els.message.hidden = !text;
  }

  function renderNoStockGroup(ctx, stores) {
    var els = ctx.els;
    if (!els.noStockGroup) return;

    els.noStockGroup.hidden = stores.length === 0;
    if (els.noStockLabel) els.noStockLabel.textContent = 'Show stores without stock (' + stores.length + ')';
    if (els.noStockToggle) els.noStockToggle.setAttribute('aria-expanded', String(ctx.noStockOpen));
    if (!els.noStockList) return;
    els.noStockList.innerHTML = renderCards(ctx, stores);
    els.noStockList.hidden = !ctx.noStockOpen;
  }

  function render(ctx) {
    var els = ctx.els;
    var stockState = getStockState(ctx);
    var loading = stockState === 'loading';

    if (els.sortLabel) els.sortLabel.textContent = ctx.location ? COPY.sortDistance : COPY.sortStock;

    if (ctx.locationError || stockState === 'error') {
      showMessage(ctx, ctx.locationError ? COPY.noResults : COPY.failure);
      return;
    }

    showMessage(ctx, '');
    var entry = getEntry(ctx, findSize(ctx, ctx.selectedSize));
    var view = buildView(ctx.stores, loading ? null : entry.quantities, ctx.location, ctx.isCic ? CIC_DISTANCE_LIMIT : 0);

    els.list.innerHTML = renderCards(ctx, view.main);
    els.list.classList.toggle('is-loading', loading);
    els.list.setAttribute('aria-busy', String(loading));
    renderNoStockGroup(ctx, view.noStock);
  }

  /* ---------------------------------------------------------------------------
     Size dropdown
     ------------------------------------------------------------------------- */

  function findSize(ctx, value) {
    if (value == null) return null;
    return ctx.sizes.find(function(size) { return size.value === value; }) || null;
  }

  function updateSizeLabel(ctx) {
    if (ctx.els.sizeCurrent) ctx.els.sizeCurrent.textContent = ctx.selectedSize;
  }

  function findOption(list, value) {
    return Array.prototype.find.call(list.querySelectorAll('[data-size-option]'), function(option) {
      return option.getAttribute('data-size-option') === value;
    });
  }

  function renderSizeOptions(ctx) {
    var list = ctx.els.sizeList;
    if (!list) return;

    var active = list.contains(document.activeElement) ? document.activeElement.getAttribute('data-size-option') : null;
    list.innerHTML = ctx.sizes.map(function(size) {
      return '<li role="option" class="StockModal__sizeOption" data-size-option="' + escapeHtml(size.value) + '"' +
        ' aria-selected="' + (size.value === ctx.selectedSize) + '"' +
        ' aria-disabled="' + isSoldOut(ctx, size) + '" tabindex="-1">' + escapeHtml(size.value) + '</li>';
    }).join('');

    var restore = active === null ? null : findOption(list, active);
    if (restore) restore.focus();
  }

  function enabledOptions(ctx) {
    return Array.prototype.slice.call(ctx.els.sizeList.querySelectorAll('[data-size-option]:not([aria-disabled="true"])'));
  }

  function openSizeList(ctx) {
    var els = ctx.els;
    renderSizeOptions(ctx);
    els.sizeList.hidden = false;
    els.sizeToggle.setAttribute('aria-expanded', 'true');

    var selected = els.sizeList.querySelector('[aria-selected="true"]:not([aria-disabled="true"])');
    var target = selected || enabledOptions(ctx)[0];
    if (target) target.focus();
  }

  function closeSizeList(ctx, returnFocus) {
    var els = ctx.els;
    if (!els.sizeList || els.sizeList.hidden) return;

    els.sizeList.hidden = true;
    els.sizeToggle.setAttribute('aria-expanded', 'false');
    if (returnFocus) els.sizeToggle.focus();
  }

  function moveOptionFocus(ctx, current, step) {
    var options = enabledOptions(ctx);
    if (!options.length) return;

    var index = options.indexOf(current);
    var next = index === -1
      ? (step > 0 ? 0 : options.length - 1)
      : Math.min(Math.max(index + step, 0), options.length - 1);
    options[next].focus();
  }

  function chooseOption(ctx, option) {
    if (option.getAttribute('aria-disabled') === 'true') return;

    selectSize(ctx, option.getAttribute('data-size-option'), true);
    closeSizeList(ctx, true);
  }

  function handleListKeydown(ctx, event) {
    var key = event.key;
    var current = event.target.closest('[data-size-option]');

    if (key === 'ArrowDown' || key === 'ArrowUp') {
      event.preventDefault();
      moveOptionFocus(ctx, current, key === 'ArrowDown' ? 1 : -1);
    } else if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
      event.preventDefault();
      if (current) chooseOption(ctx, current);
    } else if (key === 'Escape' || key === 'Esc') {
      // Keep MicroModal's document-level Escape from closing the whole modal.
      event.preventDefault();
      event.stopPropagation();
      closeSizeList(ctx, true);
    } else if (key === 'Tab') {
      closeSizeList(ctx, false);
    }
  }

  function bindSizeControl(ctx) {
    var els = ctx.els;
    if (!els.sizeToggle || !els.sizeList) return;

    var root = els.sizeSelect || els.sizeToggle.parentNode;
    els.sizeList.id = els.sizeList.id || ctx.modalId + '-size-list';
    els.sizeToggle.setAttribute('aria-controls', els.sizeList.id);

    els.sizeToggle.addEventListener('click', function() {
      if (els.sizeList.hidden) openSizeList(ctx);
      else closeSizeList(ctx, false);
    });
    els.sizeToggle.addEventListener('keydown', function(event) {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      event.preventDefault();
      openSizeList(ctx);
    });
    els.sizeList.addEventListener('click', function(event) {
      var option = event.target.closest('[data-size-option]');
      if (option) chooseOption(ctx, option);
    });
    els.sizeList.addEventListener('keydown', function(event) { handleListKeydown(ctx, event); });
    document.addEventListener('click', function(event) {
      if (!els.sizeList.hidden && !root.contains(event.target)) closeSizeList(ctx, false);
    });
  }

  function selectSize(ctx, value, fromModal) {
    var size = findSize(ctx, value);
    if (!size) return;

    ctx.autoSelect = false;
    ctx.selectedSize = value;
    updateSizeLabel(ctx);
    renderSizeOptions(ctx);
    ensureStock(ctx, size);
    render(ctx);
    if (fromModal) syncPageSize(ctx, value);
  }

  function loadSizes(ctx) {
    var model = readSizeModel();
    ctx.sizes = model.sizes;
    ctx.sizeIndex = model.sizeIndex;
    if (ctx.els.sizeSelect) ctx.els.sizeSelect.hidden = !model.hasSizeControl;

    if (model.pageSize && findSize(ctx, model.pageSize)) {
      ctx.selectedSize = model.pageSize;
      ctx.autoSelect = false;
    } else if (!findSize(ctx, ctx.selectedSize)) {
      ctx.selectedSize = ctx.sizes.length ? ctx.sizes[0].value : '';
      ctx.autoSelect = model.hasSizeControl && ctx.sizes.length > 1;
    }
    updateSizeLabel(ctx);
  }

  /* ---------------------------------------------------------------------------
     Two-way sync with the page's size swatches
     ------------------------------------------------------------------------- */

  function syncPageSize(ctx, value) {
    var section = getProductSection();
    if (!section) return;

    var radio = Array.prototype.find.call(section.querySelectorAll('.SizeSwatch__Radio'), function(input) {
      return input.value === value;
    });
    if (!radio || radio.checked) return;

    // cable-product-form listens for this change and fires variant:changed;
    // the guard plus the "differs" check in applyPageSize stop a feedback loop.
    radio.checked = true;
    ctx.syncingPage = true;
    try {
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    } finally {
      ctx.syncingPage = false;
    }
  }

  function applyPageSize(ctx, value) {
    if (value == null || ctx.sizeIndex < 0) return;

    var size = String(value);
    if (size === ctx.selectedSize && !ctx.autoSelect) return;
    if (!findSize(ctx, size)) return;
    selectSize(ctx, size, false);
  }

  function reloadSizes(ctx) {
    loadSizes(ctx);
    renderSizeOptions(ctx);
    render(ctx);
    fetchAllStock(ctx);
  }

  function onPageVariantChanged(ctx, variant) {
    if (ctx.syncingPage || !variant || !Array.isArray(variant.options) || ctx.sizeIndex < 0) return;

    var known = ctx.sizes.some(function(size) { return String(size.variantId) === String(variant.id); });
    if (!known) {
      // Another option (e.g. colour) changed on the page: rebuild the size list.
      reloadSizes(ctx);
      return;
    }
    applyPageSize(ctx, variant.options[ctx.sizeIndex]);
  }

  function bindPageSync(ctx) {
    document.addEventListener('variant:changed', function(event) {
      onPageVariantChanged(ctx, event.detail && event.detail.variant);
    });
    document.addEventListener('change', function(event) {
      var radio = event.target;
      if (ctx.syncingPage || !radio.classList || !radio.classList.contains('SizeSwatch__Radio')) return;
      if (!radio.checked || !radio.closest('[data-section-type="product"]')) return;
      applyPageSize(ctx, radio.value);
    });
  }

  /* ---------------------------------------------------------------------------
     Store cards and the "without stock" group
     ------------------------------------------------------------------------- */

  function toggleCardHours(ctx, toggle) {
    var card = toggle.closest('.StoreCard');
    if (!card) return;

    var key = card.getAttribute('data-store-key');
    var expanded = !ctx.expanded.has(key);
    if (expanded) ctx.expanded.add(key);
    else ctx.expanded.delete(key);

    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.textContent = expanded ? COPY.hoursOpen : COPY.hoursClosed;
    var body = card.querySelector('.StoreCard__hoursBody');
    if (body) body.hidden = !expanded;
    var details = card.querySelector('[data-store-details]');
    if (details) details.hidden = !expanded;
  }

  function toggleNoStock(ctx) {
    var els = ctx.els;
    ctx.noStockOpen = !ctx.noStockOpen;
    els.noStockToggle.setAttribute('aria-expanded', String(ctx.noStockOpen));
    if (els.noStockList) els.noStockList.hidden = !ctx.noStockOpen;
  }

  // One delegated listener, so re-rendered cards never leak handlers.
  function bindStoreList(ctx) {
    var els = ctx.els;
    var container = els.scroll || els.modal;

    if (els.noStockToggle && els.noStockList) {
      els.noStockList.id = els.noStockList.id || ctx.modalId + '-nostock-list';
      els.noStockToggle.setAttribute('aria-controls', els.noStockList.id);
    }

    container.addEventListener('click', function(event) {
      var hoursToggle = event.target.closest('.StoreCard__hoursToggle');
      if (hoursToggle && container.contains(hoursToggle)) {
        toggleCardHours(ctx, hoursToggle);
        return;
      }
      if (els.noStockToggle && els.noStockToggle.contains(event.target)) toggleNoStock(ctx);
    });
  }

  /* ---------------------------------------------------------------------------
     Location search
     ------------------------------------------------------------------------- */

  function loadGoogleMaps(callback, onError) {
    if (window.google && window.google.maps && window.google.maps.places) {
      callback();
      return;
    }
    var existing = document.querySelector('script[src*="maps.googleapis.com"]');
    if (existing) {
      existing.addEventListener('load', callback);
      if (onError) existing.addEventListener('error', onError);
      return;
    }
    var script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + MAPS_API_KEY + '&libraries=places';
    script.onload = callback;
    if (onError) script.onerror = onError;
    document.head.appendChild(script);
  }

  function initAutocomplete(input, onSelect) {
    loadGoogleMaps(function() {
      var autocomplete = new google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: 'au' },
        types: ['(regions)']
      });
      autocomplete.addListener('place_changed', function() {
        var place = autocomplete.getPlace();
        if (place && place.geometry && place.geometry.location) {
          onSelect(place.geometry.location.lat(), place.geometry.location.lng());
        }
      });
    });
  }

  // The Maps Geocoder also returns a promise that rejects on ZERO_RESULTS; the
  // callback handles every status, so the rejection is swallowed.
  function geocode(request, callback) {
    var pending = new google.maps.Geocoder().geocode(request, callback);
    if (pending && typeof pending.catch === 'function') pending.catch(function() {});
  }

  // Google appends the country ("Albert Park VIC 3206, Australia"); the design shows it without.
  function stripCountry(text) {
    return String(text || '').replace(/,\s*Australia\s*$/i, '');
  }

  function isSuggestionListOpen() {
    return Array.prototype.some.call(document.querySelectorAll('.pac-container'), function(el) {
      return el.offsetParent !== null && el.querySelector('.pac-item');
    });
  }

  function updateClearButton(ctx) {
    var els = ctx.els;
    if (!els.clear) return;
    els.clear.hidden = !((els.input && els.input.value) || ctx.location);
  }

  function setLocation(ctx, lat, lng, query) {
    ctx.locationSeq += 1;
    ctx.location = { lat: lat, lng: lng };
    ctx.locationQuery = cleanText(query);
    ctx.locationError = false;
    updateClearButton(ctx);
    render(ctx);
    if (ctx.els.scroll) ctx.els.scroll.scrollTop = 0;
  }

  function showLocationError(ctx) {
    ctx.location = null;
    ctx.locationQuery = '';
    ctx.locationError = true;
    updateClearButton(ctx);
    render(ctx);
  }

  function resetSearch(ctx, focusInput) {
    var input = ctx.els.input;
    if (input) input.value = '';
    ctx.locationSeq += 1;
    ctx.location = null;
    ctx.locationQuery = '';
    ctx.locationError = false;
    updateClearButton(ctx);
    render(ctx);
    if (focusInput && input) input.focus();
  }

  // With the AU restriction, unmatched text still returns OK with the whole
  // country ("Australia"); treat that as no match rather than sorting from its centre.
  function geocodedLocation(results, status) {
    var first = status === 'OK' && results && results[0];
    if (!first || !first.geometry || !first.geometry.location) return null;
    if ((first.types || []).indexOf('country') !== -1) return null;
    return first.geometry.location;
  }

  function geocodeQuery(ctx, query) {
    var seq = ++ctx.locationSeq;
    var fail = function() {
      if (seq === ctx.locationSeq) showLocationError(ctx);
    };

    loadGoogleMaps(function() {
      geocode({ address: query, componentRestrictions: { country: 'AU' } }, function(results, status) {
        if (seq !== ctx.locationSeq) return;
        var location = geocodedLocation(results, status);
        if (!location) {
          fail();
          return;
        }
        setLocation(ctx, location.lat(), location.lng(), query);
      });
    }, fail);
  }

  // Enter / submit: reuse the chosen suggestion, otherwise geocode the typed text.
  function searchTypedLocation(ctx) {
    var query = ctx.els.input ? cleanText(ctx.els.input.value) : '';
    if (!query) {
      resetSearch(ctx, false);
      return;
    }
    if (ctx.location && query === ctx.locationQuery) return;
    geocodeQuery(ctx, query);
  }

  // Reverse geocoding can lead with a plus code ("G2JG+32Q, Brisbane City…"),
  // so prefer a suburb or postcode result and never show a plus code.
  function pickReadableAddress(results) {
    var hasType = function(type) {
      return function(result) { return (result.types || []).indexOf(type) !== -1; };
    };
    var readable = results.filter(function(result) {
      return result && result.formatted_address && !hasType('plus_code')(result);
    });
    var match = readable.find(hasType('locality')) || readable.find(hasType('postal_code')) || readable[0];
    return match ? match.formatted_address : '';
  }

  function fillInputFromCoords(ctx, lat, lng) {
    var seq = ctx.locationSeq;
    loadGoogleMaps(function() {
      geocode({ location: { lat: lat, lng: lng } }, function(results, status) {
        if (seq !== ctx.locationSeq || !ctx.els.input) return;
        if (status !== 'OK' || !Array.isArray(results)) return;
        var address = stripCountry(pickReadableAddress(results));
        if (!address) return;
        ctx.els.input.value = address;
        ctx.locationQuery = cleanText(address);
        updateClearButton(ctx);
      });
    });
  }

  function useMyLocation(ctx) {
    var geoBtn = ctx.els.geo;
    if (!navigator.geolocation || geoBtn.getAttribute('aria-busy') === 'true') return;

    var seq = ++ctx.locationSeq;
    geoBtn.setAttribute('aria-busy', 'true');
    navigator.geolocation.getCurrentPosition(
      function(pos) {
        geoBtn.removeAttribute('aria-busy');
        if (seq !== ctx.locationSeq) return;
        if (ctx.els.input) ctx.els.input.value = '';
        setLocation(ctx, pos.coords.latitude, pos.coords.longitude, '');
        fillInputFromCoords(ctx, pos.coords.latitude, pos.coords.longitude);
      },
      function() {
        geoBtn.removeAttribute('aria-busy');
      },
      { enableHighAccuracy: false, timeout: 15000, maximumAge: 300000 }
    );
  }

  // A type="search" input clears itself on Escape, which left the box empty while
  // the list stayed sorted by distance. Keep the text; with Google's suggestions
  // open, Escape closes only the suggestions, not the whole modal.
  function handleInputEscape(ctx, event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    event.preventDefault();
    if (!isSuggestionListOpen()) return;
    event.stopPropagation();
    document.querySelectorAll('.pac-container').forEach(function(el) { el.style.display = 'none'; });
  }

  function bindSearch(ctx) {
    var els = ctx.els;

    if (els.form) {
      els.form.addEventListener('submit', function(event) {
        event.preventDefault();
        searchTypedLocation(ctx);
      });
    }
    if (els.input) {
      initAutocomplete(els.input, function(lat, lng) {
        var label = stripCountry(els.input.value);
        setLocation(ctx, lat, lng, label);
        // Google writes the chosen suggestion into the input after this callback.
        setTimeout(function() {
          if (stripCountry(els.input.value) === label) els.input.value = label;
        }, 0);
      });
      els.input.addEventListener('input', function() {
        updateClearButton(ctx);
        if (!els.input.value.trim()) resetSearch(ctx, false);
      });
      els.input.addEventListener('keydown', function(event) { handleInputEscape(ctx, event); });
    }
    if (els.clear) els.clear.addEventListener('click', function() { resetSearch(ctx, true); });
    if (els.geo) els.geo.addEventListener('click', function() { useMyLocation(ctx); });
  }

  /* ---------------------------------------------------------------------------
     Modal lifecycle (lazy: nothing is fetched until the modal first opens)
     ------------------------------------------------------------------------- */

  function queryElements(modalId) {
    var modal = document.getElementById(modalId);
    var hook = function(name) {
      return modal ? modal.querySelector('[data-' + name + '="' + modalId + '"]') : null;
    };

    return {
      modal: modal,
      list: hook('store-list'),
      scroll: hook('store-scroll'),
      message: hook('store-message'),
      noStockGroup: hook('nostock-group'),
      noStockToggle: hook('nostock-toggle'),
      noStockLabel: hook('nostock-label'),
      noStockList: hook('nostock-list'),
      sortLabel: hook('sort-label'),
      sizeSelect: hook('size-select'),
      sizeToggle: hook('size-toggle'),
      sizeCurrent: hook('size-current'),
      sizeList: hook('size-list'),
      form: hook('search-form'),
      input: hook('search-input'),
      clear: hook('search-clear'),
      geo: hook('geo-btn')
    };
  }

  function createContext(modalId, els) {
    return {
      modalId: modalId,
      els: els,
      isCic: els.list.getAttribute('data-is-cic') === 'true',
      initialised: false,
      stores: [],
      sizes: [],
      sizeIndex: -1,
      selectedSize: '',
      autoSelect: false,
      cache: new Map(),
      location: null,
      locationQuery: '',
      locationError: false,
      locationSeq: 0,
      expanded: new Set(),
      noStockOpen: false,
      syncingPage: false
    };
  }

  function setupModal(ctx) {
    ctx.initialised = true;
    ctx.stores = buildStores(window.theme && window.theme.stores);
    loadSizes(ctx);
    bindSizeControl(ctx);
    bindStoreList(ctx);
    bindSearch(ctx);
    bindPageSync(ctx);
    renderSizeOptions(ctx);
    render(ctx);
    fetchAllStock(ctx);
  }

  function handleOpen(ctx) {
    if (!ctx.initialised) {
      setupModal(ctx);
      return;
    }
    closeSizeList(ctx, false);
    retryFailedStock(ctx);
  }

  function watchModalOpen(ctx) {
    document.addEventListener('findinstore:open', function(event) {
      if (event.detail && event.detail.modalId === ctx.modalId) handleOpen(ctx);
    });

    // Fallback in case the modal opens without the event (e.g. MicroModal's own trigger).
    new MutationObserver(function() {
      if (ctx.els.modal.getAttribute('aria-hidden') === 'false') handleOpen(ctx);
    }).observe(ctx.els.modal, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function initModal(modalId) {
    var els = queryElements(modalId);
    if (!els.modal || !els.list) return null;

    var ctx = createContext(modalId, els);
    watchModalOpen(ctx);
    return ctx;
  }

  onReady(function() {
    // Click & Collect path is dormant per #668: clickAndCollectModal is not initialised.
    initModal('findInStoreModal');
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-item"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__swatchSwapBound) return;
    window.__swatchSwapBound = true;

    function parseSlideshowImages(value) {
      if (!value) return [];

      try {
        var images = JSON.parse(value);
        return Array.isArray(images) ? images.filter(Boolean) : [];
      } catch (error) {
        return [];
      }
    }

    function updateMobileSlideshow(card, imageJson) {
      var images = parseSlideshowImages(imageJson);
      if (!images.length) return;

      var aspect = card.querySelector('[data-product-aspect]');
      if (!aspect) return;

      var slideshow = aspect.querySelector('[data-mobile-slideshow]');
      if (!slideshow && images.length > 1) {
        slideshow = document.createElement('div');
        slideshow.className = 'ProductItem__MobileSlideshow';
        slideshow.setAttribute('data-mobile-slideshow', '');
        slideshow.innerHTML = '<div class="ProductItem__MobilePagination"></div>';
        aspect.appendChild(slideshow);
      }
      if (!slideshow) return;

      var pagination = slideshow.querySelector('.ProductItem__MobilePagination');
      if (!pagination) {
        pagination = document.createElement('div');
        pagination.className = 'ProductItem__MobilePagination';
        slideshow.appendChild(pagination);
      }

      slideshow.setAttribute('data-images', JSON.stringify(images));
      slideshow.setAttribute('data-current', '0');
      slideshow.removeAttribute('data-preloaded');
      slideshow.style.display = images.length > 1 ? '' : 'none';

      var dotsHtml = '';
      images.forEach(function(_, index) {
        dotsHtml += '<button class="ProductItem__MobileDot' + (index === 0 ? ' is-active' : '') + '" data-dot="' + index + '" type="button"></button>';
      });
      pagination.innerHTML = dotsHtml;
    }

    document.addEventListener('click', function(e) {
      var swatch = e.target.closest('[data-swatch-swap]');
      if (!swatch) return;

      var card = swatch.closest('.ProductItem');
      if (!card) return;
      e.preventDefault();

      var url = swatch.getAttribute('data-swatch-url');
      var title = swatch.getAttribute('data-swatch-title');
      var image = swatch.getAttribute('data-swatch-image');
      var altImage = swatch.getAttribute('data-swatch-alt-image');
      var slideshowImages = swatch.getAttribute('data-swatch-slideshow-images');
      var aspectRatio = swatch.getAttribute('data-swatch-aspect-ratio');
      var price = swatch.getAttribute('data-swatch-price');
      var comparePrice = swatch.getAttribute('data-swatch-compare-price');
      var onSale = swatch.getAttribute('data-swatch-on-sale') === 'true';

      // Update active swatch state
      var swatchList = swatch.closest('.color-swatch');
      if (swatchList) {
        swatchList.querySelectorAll('.product-swatch__container').forEach(function(li) {
          li.classList.remove('is-active');
        });
        swatch.closest('.product-swatch__container').classList.add('is-active');
      }

      // Update product link and image wrapper
      var productLink = card.querySelector('[data-product-link]');
      if (productLink) {
        productLink.href = url;
        productLink.setAttribute('data-handle', swatch.getAttribute('data-swatch-handle'));

        // Update alternate image class
        if (altImage) {
          productLink.classList.add('ProductItem__ImageWrapper--withAlternateImage');
        } else {
          productLink.classList.remove('ProductItem__ImageWrapper--withAlternateImage');
        }
      }

      // Update aspect ratio
      var aspectEl = card.querySelector('[data-product-aspect]');
      if (aspectEl && aspectRatio) {
        var pb = (100 / parseFloat(aspectRatio)).toFixed(2);
        aspectEl.style.paddingBottom = pb + '%';
        aspectEl.style.setProperty('--aspect-ratio', aspectRatio);
      }

      // Update main image
      var mainImg = card.querySelector('[data-product-image]');
      if (mainImg && image) {
        mainImg.src = image;
        mainImg.srcset = '';
      }

      // Update alternate image
      var altImg = card.querySelector('[data-product-alt-image]');
      if (altImage) {
        if (altImg) {
          altImg.src = altImage;
          altImg.srcset = '';
        } else if (aspectEl) {
          // Create alternate image if it doesn't exist
          var newAlt = document.createElement('img');
          newAlt.className = 'ProductItem__Image ProductItem__Image--alternate Image--fadeIn';
          newAlt.src = altImage;
          newAlt.loading = 'lazy';
          newAlt.setAttribute('data-product-alt-image', '');
          aspectEl.insertBefore(newAlt, aspectEl.firstChild);
        }
      } else if (altImg) {
        altImg.remove();
      }

      updateMobileSlideshow(card, slideshowImages);

      // Update title
      var titleLink = card.querySelector('[data-product-title-link]');
      if (titleLink) {
        titleLink.href = url;
        titleLink.textContent = title;
      }

      // Update price
      var priceList = card.querySelector('[data-product-price-list]');
      if (priceList && price) {
        var priceHtml = '';
        if (onSale && comparePrice) {
          priceHtml = '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>' + price + '</span> ';
          priceHtml += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible>' + comparePrice + '</span>';
        } else {
          priceHtml = '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + price + '</span>';
        }
        priceList.innerHTML = priceHtml;
      }
    });

  })();

  /* Mobile product card slideshow - swipe to change images */
  (function() {
    if (window.__mobileSlideshowBound) return;
    window.__mobileSlideshowBound = true;

    var isMobile = function() { return window.innerWidth <= 767; };

    document.addEventListener('touchstart', function(e) {
      if (!isMobile()) return;
      var aspect = e.target.closest('[data-product-aspect]');
      if (!aspect) return;
      var slideshow = aspect.querySelector('[data-mobile-slideshow]');
      if (!slideshow) return;

      var images = JSON.parse(slideshow.getAttribute('data-images'));
      if (!images || images.length < 2) return;

      if (!slideshow.hasAttribute('data-preloaded')) {
        slideshow.setAttribute('data-preloaded', '');
        images.forEach(function(url) { new Image().src = url; });
      }

      var startX = e.touches[0].clientX;
      var currentIndex = parseInt(slideshow.getAttribute('data-current') || '0');

      function onMove(ev) {
        var diff = Math.abs(startX - ev.touches[0].clientX);
        if (diff > 10) ev.preventDefault();
      }

      function onEnd(ev) {
        var endX = ev.changedTouches[0].clientX;
        var diff = startX - endX;

        if (Math.abs(diff) > 30) {
          if (diff > 0 && currentIndex < images.length - 1) {
            currentIndex++;
          } else if (diff < 0 && currentIndex > 0) {
            currentIndex--;
          }

          slideshow.setAttribute('data-current', currentIndex);

          var mainImg = aspect.querySelector('[data-product-image]');
          if (mainImg) {
            mainImg.src = images[currentIndex];
            mainImg.srcset = '';
          }

          var dots = slideshow.querySelectorAll('.ProductItem__MobileDot');
          dots.forEach(function(dot, i) {
            dot.classList.toggle('is-active', i === currentIndex);
          });
        }

        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onEnd);
      }

      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('touchend', onEnd);
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section-featured-collections"] && !Shopify.designMode) return;
  try {
    (function () {
    function syncArrowGrey(splide, prev, next) {
      var ctrl = splide.Components.Controller;
      var end = ctrl.getEnd();
      if (prev) prev.classList.toggle('greyed', splide.index <= 0);
      if (next) next.classList.toggle('greyed', splide.index >= end);
    }

    function mountOne(root) {
      if (root.getAttribute('data-splide-mounted') === '1') return;
      if (typeof Splide === 'undefined') return;

      var uid = root.getAttribute('data-fc-uid');
      var wrap = root.closest('.section-featured');
      if (!wrap || !uid) return;

      var prev = wrap.querySelector('.carousel-prev-' + uid);
      var next = wrap.querySelector('.carousel-next-' + uid);

      var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 4;
      var perPageMobile = parseInt(root.getAttribute('data-per-page-mobile'), 10) || 2;
      var gapVal = root.getAttribute('data-gap') || '1.5rem';
      // #575 (Nicole 29 Jun): desktop drag is opt-out (Complete the Look passes false → stationary
      // on desktop). Mobile always keeps swipe via the 767 breakpoint below.
      var dragDesktop = root.getAttribute('data-drag-desktop') !== 'false';

      var splide = new Splide(root, {
        type: 'slide',
        perPage: perPage,
        perMove: 1,
        gap: gapVal,
        padding: 0,
        arrows: false,
        pagination: false,
        drag: dragDesktop,
        speed: 400,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        breakpoints: {
          767: {
            perPage: perPageMobile,
            gap: gapVal,
            drag: true,
          },
        },
      });

      splide.mount();
      root._splideInstance = splide;
      root.setAttribute('data-splide-mounted', '1');

      if (prev) {
        prev.addEventListener('click', function () {
          splide.go('<');
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          splide.go('>');
        });
      }

      splide.on('mounted resize moved', function () {
        syncArrowGrey(splide, prev, next);
      });
      syncArrowGrey(splide, prev, next);
    }

    function mountAll() {
      document.querySelectorAll('[data-featured-collections-splide]').forEach(mountOne);
    }

    function tryMount() {
      if (typeof Splide === 'undefined') return false;
      mountAll();
      return true;
    }

    function waitAndMount() {
      if (tryMount()) return;
      var n = 0;
      var id = setInterval(function () {
        n += 1;
        if (tryMount() || n > 200) clearInterval(id);
      }, 25);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', waitAndMount);
    } else {
      waitAndMount();
    }

    document.addEventListener('shopify:section:load', function (ev) {
      if (!ev.target || !ev.target.querySelector || !ev.target.querySelector('[data-featured-collections-splide]')) return;
      if (typeof Splide !== 'undefined') {
        mountAll();
      } else {
        waitAndMount();
      }
    });

    document.addEventListener('shopify:section:unload', function (ev) {
      if (!ev.target || !ev.target.querySelectorAll) return;
      ev.target.querySelectorAll('[data-featured-collections-splide]').forEach(function (root) {
        if (root._splideInstance) {
          root._splideInstance.destroy();
          root._splideInstance = null;
        }
        root.removeAttribute('data-splide-mounted');
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section-look"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('.stl-main-carousel').forEach(function(carousel) {
      var items = carousel.querySelectorAll('.ShopTheLook__Item');
      if (items.length < 2) return;

      var section = carousel.closest('[data-section-type="shop-the-look"]');
      var dots = section.querySelectorAll('.stl-dot');
      var currentIndex = 0;

      function updateDots() {
        dots.forEach(function(d, i) {
          d.classList.toggle('is-selected', i === currentIndex);
        });
      }

      var scrollTimeout;
      carousel.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          var left = carousel.scrollLeft;
          var closest = 0;
          var closestDist = Infinity;
          items.forEach(function(item, i) {
            var dist = Math.abs(item.offsetLeft - left - carousel.offsetWidth / 2 + item.offsetWidth / 2);
            if (dist < closestDist) { closestDist = dist; closest = i; }
          });
          currentIndex = closest;
          updateDots();
        }, 100);
      });

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() {
          items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          currentIndex = i;
          updateDots();
        });
      });
    });

    document.querySelectorAll('.stl-desktop-products').forEach(function(productList) {
      var productItems = productList.querySelectorAll('.ShopTheLook__ProductItem');
      if (productItems.length < 2) return;

      var look = productList.closest('.ShopTheLook__Item');
      if (!look) return;

      var stlDots = look.querySelectorAll('.ShopTheLook__Dot');
      var currentProduct = 0;

      stlDots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var idx = parseInt(dot.dataset.productIndex, 10) - 1;
          productItems.forEach(function(p, i) {
            p.classList.toggle('is-selected', i === idx);
          });
          stlDots.forEach(function(d) { d.classList.remove('is-active'); });
          dot.classList.add('is-active');
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-modal"] && !Shopify.designMode) return;
  try {
    (function() {
    var dialog = document.getElementById('modal-size-guide');
    if (!dialog) return;

    var currentUnit = 'cm';

    // Open triggers
    document.querySelectorAll('[aria-controls="modal-size-guide"]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        renderSizeGuide();
        dialog.showModal();
      });
    });

    // Close
    dialog.querySelector('[data-close-size-guide]').addEventListener('click', function() {
      dialog.close();
    });
    dialog.addEventListener('click', function(e) {
      if (e.target === dialog) dialog.close();
    });

    // Tab switching
    dialog.querySelectorAll('[data-tab]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        dialog.querySelectorAll('[data-tab]').forEach(function(b) {
          b.classList.remove('SizeGuide__Tab--active');
        });
        this.classList.add('SizeGuide__Tab--active');
        var tab = this.dataset.tab;
        dialog.querySelectorAll('[data-panel]').forEach(function(p) {
          p.classList.toggle('SizeGuide__Panel--active', p.dataset.panel === tab);
        });
      });
    });

    // Unit toggle — clicking anywhere on the toggle swaps the unit
    var toggleEl = dialog.querySelector('.SizeGuide__Toggle');
    if (toggleEl) {
      toggleEl.addEventListener('click', function() {
        currentUnit = currentUnit === 'cm' ? 'inch' : 'cm';
        dialog.querySelectorAll('[data-unit]').forEach(function(b) {
          b.classList.toggle('SizeGuide__Unit--active', b.dataset.unit === currentUnit);
        });
        renderTables();
      });
    }

    function getProductData() {
      var el = document.querySelector('[data-product-json]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch(e) { return null; }
    }

    function getData() {
      var el = document.querySelector('#shopify-section-theme-size-guides script[type="application/json"]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch(e) { return null; }
    }

    function getCategoryFromTags(tags) {
      if (!tags) return '';
      var tagArr = Array.isArray(tags) ? tags : tags.split(',').map(function(t) { return t.trim(); });
      var cat = tagArr.find(function(t) { return t.toLowerCase().indexOf('x-category') === 0; });
      return cat ? cat.split(':')[1].toLowerCase() : '';
    }

    function matchesCategory(titleField, category) {
      if (!titleField) return false;
      if (!category) return false;
      var parts = titleField.split(',').map(function(t) { return t.trim().toLowerCase(); });
      return parts.some(function(part) {
        return category.indexOf(part) !== -1 || (category + 's').indexOf(part) !== -1;
      });
    }

    function cmToInch(val) {
      var num = parseFloat(val);
      if (isNaN(num)) return val;
      return Math.round(num * 0.393701);
    }

    function convertCell(val) {
      if (currentUnit !== 'inch') return val;
      var num = parseFloat(val);
      if (!isNaN(num) && val.trim() === String(num)) {
        return cmToInch(num);
      }
      return val.replace(/(\d+\.?\d*)\s*cm/gi, function(m, n) { return cmToInch(n) + '"'; });
    }

    function parseRows(settings, prefix) {
      var rows = [];
      for (var i = 1; i <= 9; i++) {
        var row = settings[prefix + i];
        if (row) rows.push(row.split(',').map(function(c) { return c.trim(); }));
      }
      return rows;
    }

    // Build TRANSPOSED table for body measurements:
    // Input rows: [0]=["Size","6/XXS","8/XS",...], [1]=["Bust","81","86",...], [2]=["Waist",...]
    // Output: headers = Size, Bust, Waist, Hips; rows = 6/XXS | 81 | 63 | 90
    function buildTransposedTable(settings, prefix) {
      var rows = parseRows(settings, prefix);
      if (rows.length === 0) return '';

      var numCols = rows.length;
      var numRows = rows[0].length - 1;

      var t = '<div class="SizeGuide__TableWrap">';
      if (settings.dual_size1 || settings.dual_size2) {
        var dataCols = numCols - 1;
        var halfCols = Math.ceil(dataCols / 2);
        t += '<table class="SizeGuide__Legend"><tr><td class="SizeGuide__LegendSpacer"></td>';
        t += '<td colspan="' + halfCols + '" class="SizeGuide__LegendLabel SizeGuide__LegendLabel--left">' + (settings.dual_size1 || 'Small / Medium') + '</td>';
        t += '<td colspan="' + (dataCols - halfCols) + '" class="SizeGuide__LegendLabel">' + (settings.dual_size2 || 'Medium / Large') + '</td>';
        t += '</tr></table>';
      }
      t += '<table class="SizeGuide__Table" data-measurement="true"><thead><tr>';
      for (var c = 0; c < numCols; c++) {
        t += '<th data-col="' + c + '">' + rows[c][0] + '</th>';
      }
      t += '</tr></thead><tbody>';

      for (var r = 1; r <= numRows; r++) {
        t += '<tr>';
        for (var c2 = 0; c2 < numCols; c2++) {
          var cell = (rows[c2] && rows[c2][r]) || '';
          if (c2 === 0) {
            t += '<th data-col="' + c2 + '">' + cell + '</th>';
          } else {
            t += '<td data-col="' + c2 + '">' + convertCell(cell) + '</td>';
          }
        }
        t += '</tr>';
      }
      t += '</tbody></table></div>';
      return t;
    }

    // Build TRANSPOSED table for size conversion too:
    // Same transpose logic — sizes go down, regions go across
    function buildTransposedConversionTable(settings, prefix) {
      var rows = parseRows(settings, prefix);
      if (rows.length === 0) return '';

      var numCols = rows.length;
      var numRows = rows[0].length - 1;

      var t = '<div class="SizeGuide__TableWrap"><table class="SizeGuide__Table"><thead><tr>';
      for (var c = 0; c < numCols; c++) {
        t += '<th data-col="' + c + '">' + rows[c][0] + '</th>';
      }
      t += '</tr></thead><tbody>';

      for (var r = 1; r <= numRows; r++) {
        t += '<tr>';
        for (var c2 = 0; c2 < numCols; c2++) {
          var cell = (rows[c2] && rows[c2][r]) || '';
          if (c2 === 0) {
            t += '<th data-col="' + c2 + '">' + cell + '</th>';
          } else {
            t += '<td data-col="' + c2 + '">' + convertCell(cell) + '</td>';
          }
        }
        t += '</tr>';
      }
      t += '</tbody></table></div>';
      return t;
    }

    // Column + row hover highlighting (cross-hair effect)
    function initTableHover() {
      var tables = dialog.querySelectorAll('.SizeGuide__Table');
      tables.forEach(function(table) {
        var cells = table.querySelectorAll('th[data-col], td[data-col]');
        cells.forEach(function(cell) {
          cell.addEventListener('mouseenter', function() {
            var col = this.getAttribute('data-col');
            if (col !== null) {
              table.querySelectorAll('[data-col="' + col + '"]').forEach(function(c) {
                c.classList.add('SizeGuide__ColHover');
              });
            }
            var row = this.parentElement;
            if (row) {
              row.classList.add('SizeGuide__RowHover');
            }
          });
          cell.addEventListener('mouseleave', function() {
            table.querySelectorAll('.SizeGuide__ColHover').forEach(function(c) {
              c.classList.remove('SizeGuide__ColHover');
            });
            var row = this.parentElement;
            if (row) {
              row.classList.remove('SizeGuide__RowHover');
            }
          });
        });
      });
    }

    var matchedBody = null;
    var matchedConversion = null;
    var matchedSteps = null;
    var productData = null;

    function renderSizeGuide() {
      var data = getData();
      productData = getProductData();

      if (!data || !data.blocks) return;

      var product = productData ? productData.product : null;
      var category = product ? getCategoryFromTags(product.tags) : '';

      matchedBody = null;
      matchedConversion = null;
      matchedSteps = null;

      var useCategory = !!category;
      var productType = product ? (product.type || '') : '';

      data.blocks.forEach(function(block) {
        var titleField;
        if (block.type === 'sizes_body' && !matchedBody) {
          titleField = block.settings.title_size || '';
          if (useCategory ? matchesCategory(titleField, category) : matchesFallback(titleField, productType)) {
            matchedBody = block;
          }
        }
        if (block.type === 'sizes_conversion' && !matchedConversion) {
          titleField = block.settings.title_conversion || '';
          if (useCategory ? matchesCategory(titleField, category) : matchesFallback(titleField, productType)) {
            matchedConversion = block;
          }
        }
        if (block.type === 'steps' && !matchedSteps) {
          titleField = block.settings.title_step || '';
          if (useCategory ? matchesCategory(titleField, category) : matchesFallback(titleField, productType)) {
            matchedSteps = block;
          }
        }
      });

      var categoryEl = document.getElementById('size-guide-category');
      categoryEl.textContent = (matchedBody && matchedBody.settings.title_size) ||
                               (matchedConversion && matchedConversion.settings.title_conversion) || '';

      var tabsEl = document.getElementById('size-guide-tabs');
      var isShoes = matchedConversion && matchedConversion.settings.title_conversion === 'Shoes';
      if (!matchedSteps || isShoes) {
        tabsEl.classList.add('SizeGuide__Tabs--hidden');
      } else {
        tabsEl.classList.remove('SizeGuide__Tabs--hidden');
      }

      renderTables();
      renderProductCard();
      renderMeasurementGuide();
    }

    function matchesFallback(titleField, productType) {
      if (!productType || !titleField) return !productType;
      var types = titleField.split(',').map(function(t) { return t.trim().toLowerCase(); });
      return types.indexOf(productType.toLowerCase()) !== -1;
    }

    function renderTables() {
      var tablesEl = document.getElementById('size-guide-tables');
      var noteEl = document.getElementById('size-guide-note');
      var emailEl = document.getElementById('size-guide-email');
      var bodyTitleEl = document.getElementById('size-guide-body-title');

      var html = '';

      if (matchedBody) {
        noteEl.innerHTML = (matchedBody.settings.note || '').split('.').filter(function(s) { return s.trim(); }).map(function(s) { return s.trim() + '.'; }).join('<br>');
        bodyTitleEl.textContent = matchedBody.settings.table1 || '';
        html += buildTransposedTable(matchedBody.settings, 'body_row');
        emailEl.innerHTML = matchedBody.settings.email || '';
      } else {
        noteEl.textContent = '';
        bodyTitleEl.textContent = '';
        emailEl.innerHTML = '';
      }

      if (matchedConversion) {
        html += '<p class="SizeGuide__ConversionTitle">' + (matchedConversion.settings.table2 || '') + '</p>';
        html += buildTransposedConversionTable(matchedConversion.settings, 'conversion_row');
      }

      tablesEl.innerHTML = html || '<p>No size guide available for this product type.</p>';

      // Re-init hover after rendering
      initTableHover();
    }

    function renderProductCard() {
      var col = document.getElementById('size-guide-product-col');
      if (!productData || !productData.product) {
        col.innerHTML = '';
        return;
      }

      var product = productData.product;
      var selectedId = productData.selected_variant_id;
      var image = product.featured_image || (product.images && product.images[0]) || '';
      var imageSrc = typeof image === 'string' ? image : image.src || '';

      if (imageSrc) {
        imageSrc = imageSrc.replace(/_\d+x(\d+)?\./, '.').replace(/\?.*$/, '');
        imageSrc += '?width=460';
      }

      var html = '<div class="SizeGuide__Product">';
      html += '<p class="SizeGuide__ProductTitle">' + product.title + '</p>';
      if (imageSrc) {
        html += '<div class="SizeGuide__ProductImage"><img src="' + imageSrc + '" alt="' + product.title + '" loading="lazy"></div>';
      }

      var sizeOptionKey = 'option1';
      if (product.variants.length > 0) {
        for (var oi = 1; oi <= 3; oi++) {
          var key = 'option' + oi;
          var vals = product.variants.map(function(v) { return v[key]; }).filter(Boolean);
          var unique = vals.filter(function(v, i, a) { return a.indexOf(v) === i; });
          if (unique.length <= 1) continue;
          var looksLikeSize = unique.some(function(v) {
            return /^\d+$/.test(v) || /^(XXS|XS|S|M|L|XL|XXL|XXXL|ONE SIZE)$/i.test(v);
          });
          if (looksLikeSize) { sizeOptionKey = key; break; }
        }
      }

      var seenSizes = {};

      html += '<div class="SizeGuide__ProductSizes"><p>Select Size</p>';
      html += '<div class="SizeGuide__VariantGrid">';
      product.variants.forEach(function(v) {
        var label = v[sizeOptionKey] || v.title || '';
        if (seenSizes[label]) return;
        seenSizes[label] = true;
        var isActive = v.id === selectedId;
        var isAvailable = v.available;
        var cls = 'SizeGuide__VariantBtn';
        if (isActive) cls += ' SizeGuide__VariantBtn--active';
        if (!isAvailable) cls += ' SizeGuide__VariantBtn--unavailable';
        html += '<button class="' + cls + '" data-variant-id="' + v.id + '">' + label + '</button>';
      });
      html += '</div></div>';

      html += '<button class="SizeGuide__AddToCart" id="size-guide-add-to-cart">ADD TO CART</button>';
      html += '</div>';

      col.innerHTML = html;

      col.querySelectorAll('.SizeGuide__VariantBtn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var variantId = parseInt(this.dataset.variantId);
          col.querySelectorAll('.SizeGuide__VariantBtn').forEach(function(b) {
            b.classList.remove('SizeGuide__VariantBtn--active');
          });
          this.classList.add('SizeGuide__VariantBtn--active');
          var mainLabel = document.querySelector('label[data-variant-id="' + variantId + '"]');
          if (mainLabel) mainLabel.click();
        });
      });

      var addBtn = document.getElementById('size-guide-add-to-cart');
      if (addBtn) {
        addBtn.addEventListener('click', function() {
          var activeBtn = col.querySelector('.SizeGuide__VariantBtn--active');
          if (!activeBtn) return;
          var variantId = activeBtn.dataset.variantId;
          var mainLabel = document.querySelector('label[data-variant-id="' + variantId + '"]');
          if (mainLabel) mainLabel.click();
          setTimeout(function() {
            var mainAddBtn = document.querySelector('form[action="/cart/add"] button[type="submit"], form[action="/cart/add"] input[type="submit"]');
            if (mainAddBtn) mainAddBtn.click();
          }, 100);
          dialog.close();
        });
      }
    }

    function renderMeasurementGuide() {
      var contentEl = document.getElementById('measurement-guide-content');
      var noteEl = document.getElementById('measurement-guide-note');
      var emailEl = document.getElementById('measurement-guide-email');

      if (!matchedSteps) {
        noteEl.textContent = '';
        contentEl.innerHTML = '';
        emailEl.innerHTML = '';
        return;
      }

      noteEl.textContent = matchedSteps.settings.measure_notes || '';

      var html = '<div class="SizeGuide__MeasureStep">';
      html += '<div class="SizeGuide__MeasureText">';
      html += '<p class="SizeGuide__MeasureHeading">How to Measure</p>';
      if (matchedSteps.settings.content) {
        html += '<div>' + matchedSteps.settings.content + '</div>';
      }
      html += '</div>';

      if (matchedSteps.settings.image) {
        var imgSrc = matchedSteps.settings.image;
        html += '<div class="SizeGuide__MeasureImage">';
        html += '<img src="' + imgSrc + '" alt="How to measure" loading="lazy">';
        html += '</div>';
      }
      html += '</div>';

      contentEl.innerHTML = html;

      if (matchedBody && matchedBody.settings.email) {
        emailEl.innerHTML = matchedBody.settings.email;
      } else {
        emailEl.innerHTML = '';
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tagalys-instant-search"] && !Shopify.designMode) return;
  try {
    (function() {
    var cfg = window.__tagalysInstantSearch;
    if (!cfg) return;

    var container = document.querySelector('[data-instant-search]');
    var inner = document.querySelector('[data-instant-search-inner]');
    if (!container || !inner) return;

    var activeInput = null;
    var currentQuery = '';
    var lastResponse = null;
    var debounceTimer = null;
    var isVisible = false;

    // --- Utilities ---

    function esc(str) {
      if (!str) return '';
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }

    function formatMoney(cents) {
      if (window.Cable && window.Cable.formatMoney) {
        return window.Cable.formatMoney(cents, cfg.moneyFormat);
      }
      var dollars = (cents / 100).toFixed(2);
      return '$' + dollars.replace(/\.00$/, '');
    }

    // --- Recent searches (localStorage) ---

    var STORAGE_KEY = 'cable_recent_searches';
    var MAX_RECENT = 5;

    function getRecentSearches() {
      try {
        var data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(data) ? data.slice(0, MAX_RECENT) : [];
      } catch (e) { return []; }
    }

    function addRecentSearch(term) {
      if (!term || !term.trim()) return;
      term = term.trim();
      var searches = getRecentSearches().filter(function(s) {
        return s.toLowerCase() !== term.toLowerCase();
      });
      searches.unshift(term);
      if (searches.length > MAX_RECENT) searches = searches.slice(0, MAX_RECENT);
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(searches)); } catch(e) {}
    }

    function removeRecentSearch(term) {
      var searches = getRecentSearches().filter(function(s) {
        return s !== term;
      });
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(searches)); } catch(e) {}
    }

    // --- Show / Hide ---

    function show() {
      container.style.display = '';
      isVisible = true;
    }

    function hide() {
      container.style.display = 'none';
      isVisible = false;
    }

    // --- Render: focus state (recent + popular) ---

    var cachedPopular = null;

    function renderFocusState() {
      var recent = getRecentSearches();

      if (tagalysReady && tagalysInstance && tagalysInstance.helpers) {
        renderRecentAndPopular(recent, cachedPopular || []);

        if (cachedPopular === null) {
          tagalysInstance.helpers.getPopularSearches(MAX_RECENT).then(function(response) {
            cachedPopular = (response || []).map(function(item) { return item.query || ''; }).filter(Boolean);
            if (currentQuery.length < 2 && isVisible) {
              renderRecentAndPopular(getRecentSearches(), cachedPopular);
            }
          });
        }
      } else {
        renderRecentAndPopular(recent, []);
      }
    }

    function renderRecentAndPopular(recent, popular) {
      var recentLower = recent.map(function(s) { return s.toLowerCase(); });
      popular = (popular || []).filter(function(term) {
        return recentLower.indexOf(term.toLowerCase()) === -1;
      });

      if (!recent.length && !popular.length) {
        inner.innerHTML = '';
        hide();
        return;
      }

      var html = '';

      if (recent.length) {
        html += '<div class="tis__section">';
        html += '<div class="tis__heading">Recent searches</div>';
        recent.forEach(function(term) {
          html += '<div class="tis__recent-row">';
          html += '<a href="/search?q=' + encodeURIComponent(term) + '&type=product" class="tis__item-link tis__recent-link" data-recent-term="' + esc(term) + '">' + esc(term) + '</a>';
          html += '<button class="tis__remove" data-remove-recent="' + esc(term) + '" aria-label="Remove" type="button">&times;</button>';
          html += '</div>';
        });
        html += '</div>';
      }

      if (popular.length) {
        html += '<div class="tis__section">';
        html += '<div class="tis__heading">Popular searches</div>';
        popular.forEach(function(term) {
          html += '<a href="/search?q=' + encodeURIComponent(term) + '&type=product" class="tis__item-link" data-suggestion-query="' + esc(term) + '">' + esc(term) + '</a>';
        });
        html += '</div>';
      }

      inner.innerHTML = html;
      show();
    }

    // --- Render: search results ---
    // data shape: { suggestions[], collections[], products[], totalCount }

    function renderResults(data) {
      lastResponse = data;
      var suggestions = (data.suggestions || []).slice(0, 5);
      var products = (data.products || []).slice(0, 4);
      var totalCount = data.totalCount || 0;

      var html = '';
      var q = currentQuery;

      // View results link
      var viewLabel = totalCount > 0
        ? 'View ' + totalCount + ' Results'
        : 'View Results';
      html += '<div class="tis__view-results">';
      html += '<a href="/search?q=' + encodeURIComponent(q) + '&type=product" class="tis__view-results-link" data-cta-search>' + viewLabel + '</a>';
      html += '</div>';

      html += '<div class="tis__columns">';

      // Left column: suggestions
      if (suggestions.length) {
        html += '<div class="tis__suggestions">';
        suggestions.forEach(function(item) {
          html += '<a href="' + esc(item.url) + '" class="tis__suggestion-link" data-suggestion-query="' + esc(item.text) + '">' + (item.styledText || esc(item.text)) + '</a>';
        });
        html += '</div>';
      }

      // Right column: product grid
      if (products.length) {
        html += '<div class="tis__products-grid">';
        products.forEach(function(p) {
          var imgSrc = p.image || '';
          if (imgSrc && imgSrc.indexOf('?') === -1) imgSrc += '?width=400';
          if (imgSrc && imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
          var onSale = p.comparePriceCents > p.priceCents && p.comparePriceCents > 0;

          var altImgSrc = p.altImage || '';
          if (altImgSrc && altImgSrc.indexOf('?') === -1) altImgSrc += '?width=400';
          if (altImgSrc && altImgSrc.indexOf('//') === 0) altImgSrc = 'https:' + altImgSrc;

          html += '<div class="tis__product-card">';
          html += '<a href="' + esc(p.url) + '" class="tis__product-img-wrap">';
          if (onSale) {
            html += '<span class="tis__product-badge">SALE</span>';
          }
          if (imgSrc) {
            html += '<img class="tis__product-img tis__product-img--main" src="' + esc(imgSrc) + '" width="400" height="600" loading="lazy" alt="' + esc(p.title) + '" />';
          }
          if (altImgSrc) {
            html += '<img class="tis__product-img tis__product-img--alt" src="' + esc(altImgSrc) + '" width="400" height="600" loading="lazy" alt="' + esc(p.title) + '" />';
          }
          html += '</a>';
          html += '<div class="tis__product-info">';
          html += '<a href="' + esc(p.url) + '" class="tis__product-title">' + esc(p.title) + '</a>';
          if (p.id) {
            html += '<button type="button" class="wk-button-collection wk-add-product" title="Add to Wishlist" aria-label="Add to Wishlist" data-wk-add-product="' + esc(p.id) + '">';
            html += '<div class="wk-icon"><svg class="fill-current" viewBox="0 0 24 24"><title>icon-heart</title><path d="M23,3.46A6.18,6.18,0,0,0,17.56.21,7.49,7.49,0,0,0,12,3.06,7.49,7.49,0,0,0,6.44.21H6.38A6.27,6.27,0,0,0,1,3.46c-3,4.82.56,11.77,10.34,20.1a.92.92,0,0,0,1.24,0C22.4,15.23,26,8.28,23,3.46Zm-11,18C3.71,14.21.4,8.25,2.68,4.6a4.36,4.36,0,0,1,3.7-2.33h0a6,6,0,0,1,4.75,3.06,1,1,0,0,0,1.66,0,6,6,0,0,1,4.75-3.06A4.49,4.49,0,0,1,21.32,4.6C23.6,8.25,20.29,14.21,12,21.43Z"></path></svg></div>';
            html += '<span class="wk-label hidden">Add to Wishlist</span>';
            html += '</button>';
          }
          html += '<div class="tis__product-price">';
          if (onSale) {
            html += '<span class="tis__price tis__price--sale">' + formatMoney(p.priceCents) + '</span> ';
            html += '<span class="tis__price tis__price--compare">' + formatMoney(p.comparePriceCents) + '</span>';
          } else {
            html += '<span class="tis__price">' + formatMoney(p.priceCents) + '</span>';
          }
          html += '</div>';
          html += '</div>';
          html += '</div>';
        });
        html += '</div>';
      }

      html += '</div>';

      inner.innerHTML = html;
      show();
    }

    // =====================================================================
    // API: Tagalys Search Suggestions (SDK APIConnector)
    // =====================================================================

    var tagalysInstance = null;
    var tagalysReady = false;
    var pendingTagalysQuery = null;

    function initTagalys() {
      if (!window.onTagalysReady) return;
      window.onTagalysReady(function() {
        var connector = Tagalys.APIConnector;
        if (!connector || !connector.SearchSuggestions) return;

        tagalysInstance = connector.SearchSuggestions.new({
          params: {
            sections: {
              popular_searches: { count: 5 },
              collections: { count: 5 },
              products: {
                include: ['total_count', 'items'],
                count: 6
              }
            }
          },
          onSuccess: function(response) {
            renderResults(normalizeTagalys(response));
          },
          onFailure: function() {
            hide();
          }
        });

        tagalysReady = true;

        if (pendingTagalysQuery) {
          var q = pendingTagalysQuery;
          pendingTagalysQuery = null;
          tagalysInstance.helpers.updateQuery(q, 300);
        }
      });
    }

    function callTagalysSearch(query) {
      if (!tagalysReady || !tagalysInstance) {
        pendingTagalysQuery = query;
        return;
      }
      tagalysInstance.helpers.updateQuery(query, 300);
    }

    function normalizeTagalys(response) {
      var suggestions = [];
      var collections = [];
      var products = [];
      var totalCount = 0;
      var sections = response.sections || {};

      if (sections.collections && sections.collections.items) {
        sections.collections.items.forEach(function(item) {
          collections.push({
            title: item.title || item.displayString || '',
            url: item.link || ''
          });
        });
      }

      Object.keys(sections).forEach(function(key) {
        if (key === 'products' || key === 'collections') return;
        var section = sections[key];
        if (!section.items) return;
        section.items.forEach(function(item) {
          var text = item.displayString || item.title || item.query || '';
          if (!text) return;
          var url = item.link || '';
          if (!url && item.queryString) {
            url = '/search?' + item.queryString;
          }
          suggestions.push({ text: text, styledText: null, url: url || ('/search?q=' + encodeURIComponent(text) + '&type=product') });
        });
      });

      if (sections.products) {
        totalCount = sections.products.total_count || 0;
        (sections.products.items || []).forEach(function(p) {
          var imgSrc = '';
          var altImgSrc = '';
          if (p.featured_image && p.featured_image.src) imgSrc = p.featured_image.src;
          if (p.images && p.images.length > 1 && p.images[1].src) altImgSrc = p.images[1].src;
          products.push({
            id: p.id || '',
            title: p.title || '',
            handle: p.handle || '',
            url: '/products/' + p.handle,
            image: imgSrc,
            altImage: altImgSrc,
            priceCents: Math.round((p.price || 0) * 100),
            comparePriceCents: Math.round((p.compare_at_price || 0) * 100)
          });
        });
      }

      return { suggestions: suggestions, collections: collections, products: products, totalCount: totalCount };
    }

    // --- Event handling ---

    function onFocus(e) {
      activeInput = e.target;
      var val = activeInput.value.trim();
      if (val.length >= 2) {
        if (lastResponse && currentQuery === val) {
          renderResults(lastResponse);
        } else {
          currentQuery = val;
          callTagalysSearch(val);
        }
      } else {
        renderFocusState();
      }
    }

    function onInput(e) {
      var val = e.target.value.trim();
      activeInput = e.target;
      currentQuery = val;

      if (debounceTimer) clearTimeout(debounceTimer);

      if (val.length < 2) {
        lastResponse = null;
        renderFocusState();
        return;
      }

      // Tagalys SDK debounces internally via updateQuery's second param
      callTagalysSearch(val);
    }

    function onFormSubmit(e) {
      var input = e.target.querySelector('input[name="q"]');
      if (input && input.value.trim()) {
        addRecentSearch(input.value.trim());
      }
      hide();
    }

    function bindInput(input) {
      if (!input) return;
      input.addEventListener('focus', onFocus);
      input.addEventListener('input', onInput);

      var form = input.closest('form');
      if (form) {
        form.addEventListener('submit', onFormSubmit);
      }
    }

    // --- Event delegation on container ---

    container.addEventListener('click', function(e) {
      var removeBtn = e.target.closest('[data-remove-recent]');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        removeRecentSearch(removeBtn.getAttribute('data-remove-recent'));
        renderFocusState();
        if (activeInput) activeInput.focus();
        return;
      }

      var recentLink = e.target.closest('[data-recent-term]');
      if (recentLink) {
        addRecentSearch(recentLink.getAttribute('data-recent-term'));
        return;
      }

      var suggestionLink = e.target.closest('[data-suggestion-query]');
      if (suggestionLink) {
        addRecentSearch(suggestionLink.getAttribute('data-suggestion-query'));
        return;
      }

      var ctaBtn = e.target.closest('[data-cta-search]');
      if (ctaBtn) {
        addRecentSearch(currentQuery);
        return;
      }
    });

    // --- Global: hide on Escape ---

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isVisible) {
        hide();
      }
    });

    // --- Hide when search modal closes ---

    var searchModal = document.getElementById('Search');
    if (searchModal) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          if (m.attributeName === 'aria-hidden') {
            var hidden = searchModal.getAttribute('aria-hidden');
            if (hidden === 'true' && isVisible) {
              hide();
              lastResponse = null;
              currentQuery = '';
            }
          }
        });
      });
      observer.observe(searchModal, { attributes: true });
    }

    // --- Init ---

    function init() {
      var searchInput = document.querySelector('#Search .Search__Input');
      bindInput(searchInput);
      initTagalys();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
